module.exports = __webpack_public_path__ + "static/media/Koch Supply & Trading.b0dace90.svg";